export const NAME = 'auth';